import api from './api'

// ⚠️ ENDPOINT REAL DE BIND - Backend hace proxy
// El backend llama a: POST https://sandbox.bind.com.ar/v1/login/jwt
export async function login(username, password, extra = {}) {
  const response = await api.post('/auth/login', { username, password, ...extra })
  return response.data
}

export async function logout() {
  const response = await api.post('/auth/logout')
  return response.data
}

export async function checkAuth() {
  const response = await api.get('/auth/check')
  return response.data
}

/**
 * Obtener CVUs asignados al usuario actual (solo para usuarios del portal)
 */
export async function getMyAccounts() {
  const role = localStorage.getItem('user_role')
  const endpoint = role === 'BIND' ? '/bind-users/my-accounts' : '/users/my-accounts'
  const response = await api.get(endpoint)
  return response.data
}

/**
 * Re-autenticar usuario para operaciones sensibles
 * Usa el username guardado en localStorage
 */
export async function verifyPassword(password) {
  const username = localStorage.getItem('username')
  if (!username) {
    throw new Error('No se encontró el usuario. Por favor, inicie sesión nuevamente.')
  }
  
  const response = await api.post('/auth/login', { username, password })
  return response.data
}

